import { _ as t } from "./main52.js";
var e = t;
function r(a) {
  return e(this, a).get(a);
}
var m = r;
export {
  m as _
};
